export const storage = {
  sessionIdKey: 'session_id',
};
